export const SET_A_PAGINATION = 'SET_A_PAGINATION';
export const REMOVE_A_PAGINATION = 'REMOVE_A_PAGINATION';
export const CHANGE_PAGE = 'CHANGE_PAGE';